<!-- @format -->

<ng-container *transloco="let t">
  <sis-description-list [fillByColumn]="false">
    <dl>
      @if (!isStudentInfo) {
        <ng-container>
          <ng-template #listItem>
            <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.NAME_SPECIFIER") }}</dt>
            <dd>
              <sis-course-unit-info-modal-text-field [localizedStringValue]="assessmentItem.nameSpecifier" [language]="language">
              </sis-course-unit-info-modal-text-field>
            </dd>
          </ng-template>
          <ng-template #listItem>
            <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.TYPE") }}</dt>
            <dd>{{ assessmentItem.assessmentItemType | codeLocalizedName | async }}</dd>
          </ng-template>
        </ng-container>
      }
      @if (assessmentItem.possibleAttainmentLanguages?.length > 0 || showEmptyFields) {
        <ng-template #listItem>
          <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.POSSIBLE_ATTAINMENT_LANGUAGES") }}</dt>
          <dd>
            @if (assessmentItem.possibleAttainmentLanguages?.length > 0) {
              <ng-container>
                @for (languageUrn of assessmentItem.possibleAttainmentLanguages; track languageUrn) {
                  <ng-container>
                    {{ languageUrn | codeLocalizedName | async }}
                  </ng-container>
                }
              </ng-container>
            } @else {
              <ng-template [ngTemplateOutlet]="noContent"></ng-template>
            }
          </dd>
        </ng-template>
      }
      @if (assessmentItem.studyFormat || showEmptyFields) {
        <ng-template #listItem>
          <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.STUDY_FORMAT") }}</dt>
          <dd>
            @if (useLocalizationFallback) {
              <sis-localized-markup-string-view [content]="assessmentItem.studyFormat"> </sis-localized-markup-string-view>
            }
            @if (!useLocalizationFallback) {
              <sis-course-unit-info-modal-text-field [localizedMarkupStringValue]="assessmentItem.studyFormat" [language]="language">
              </sis-course-unit-info-modal-text-field>
            }
          </dd>
        </ng-template>
      }
      @if (assessmentItem.learningMaterial || showEmptyFields) {
        <ng-template #listItem>
          <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.LEARNING_MATERIAL") }}</dt>
          <dd>
            @if (useLocalizationFallback) {
              <sis-localized-markup-string-view [content]="assessmentItem.learningMaterial"> </sis-localized-markup-string-view>
            }

            @if (!useLocalizationFallback) {
              <sis-course-unit-info-modal-text-field [localizedMarkupStringValue]="assessmentItem.learningMaterial" [language]="language">
              </sis-course-unit-info-modal-text-field>
            }
          </dd>
        </ng-template>
      }
      @if (assessmentItem.literature?.length > 0 || showEmptyFields) {
        <ng-template #listItem>
          <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.LITERATURE") }}</dt>
          <dd>
            @if (assessmentItem.literature?.length > 0) {
              <ng-container>
                @for (item of assessmentItem.literature; track item) {
                  <sis-literature [literature]="item"></sis-literature>
                }
              </ng-container>
            } @else {
              <ng-template [ngTemplateOutlet]="noContent"></ng-template>
            }
          </dd>
        </ng-template>
      }
      @if (assessmentItem.contentDescription || showEmptyFields) {
        <ng-template #listItem>
          <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.CONTENT_DESCRIPTION") }}</dt>
          <dd>
            @if (useLocalizationFallback) {
              <sis-localized-markup-string-view [content]="assessmentItem.contentDescription"> </sis-localized-markup-string-view>
            }
            @if (!useLocalizationFallback) {
              <sis-course-unit-info-modal-text-field [localizedMarkupStringValue]="assessmentItem.contentDescription" [language]="language">
              </sis-course-unit-info-modal-text-field>
            }
          </dd>
        </ng-template>
      }
      @if (assessmentItem.grading || showEmptyFields) {
        <ng-template #listItem>
          <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.GRADING") }}</dt>
          <dd>
            @if (useLocalizationFallback) {
              <sis-localized-markup-string-view [content]="assessmentItem.grading"> </sis-localized-markup-string-view>
            }
            @if (!useLocalizationFallback) {
              <sis-course-unit-info-modal-text-field [localizedMarkupStringValue]="assessmentItem.grading" [language]="language">
              </sis-course-unit-info-modal-text-field>
            }
          </dd>
        </ng-template>
      }
      @if (assessmentItem.studyField || showEmptyFields) {
        <ng-template #listItem>
          <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.STUDY_FIELD") }}</dt>
          <dd>
            @if (assessmentItem.studyField) {
              <ng-container>
                {{ assessmentItem.studyField | codeLocalizedName | async }}
              </ng-container>
            } @else {
              <ng-template [ngTemplateOutlet]="noContent"></ng-template>
            }
          </dd>
        </ng-template>
      }
    </dl>
  </sis-description-list>

  <div class="row">
    <div class="col-12 form-group-mimic">
      <div
        role="heading"
        [attr.aria-level]="responsibilityInfoHeaderLevel"
        class="{{ assessmentItem.responsibilityInfos?.length > 0 ? 'fudis-heading__md sis-mb-sm sis-mt-sm' : 'sis-label' }}">
        {{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.RESPONSIBILITY_INFOS") }}
      </div>
      @if (assessmentItem.responsibilityInfos?.length > 0) {
        <ng-container>
          <sis-module-responsibility-info
            [responsibilityInfos]="assessmentItem.responsibilityInfos"
            [language]="language"></sis-module-responsibility-info>
        </ng-container>
      } @else {
        <ng-template [ngTemplateOutlet]="noContent"></ng-template>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <sis-responsible-organisation-info [organisations]="assessmentItem.organisations"></sis-responsible-organisation-info>
    </div>
  </div>

  <ng-template #noContent>
    <p class="sis-placeholder">
      <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
    </p>
  </ng-template>
</ng-container>
